import React from "react";

const Status = ({ infos, message }) => {
  return (
    <div
      className={
        infos.length > 0 ? "card rounded-semi" : "card rounded-semi d-none"
      }
      style={{ height: "450px" }}
    >
      <div className="card-header top-rounded-semi">Status</div>
      <div className="card-body">
        <div className="vertical-scroll" style={{ maxHeight: "360px" }}>
          <div>
            {infos &&
              infos.map((p, index) => (
                <div className=" mb-2" key={index}>
                  <div style={{ width: "100%" }}>
                    <label style={{ display: "block" }}>{p.fileName}</label>
                  </div>
                  <div>
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-info rounded"
                        role="progressbar"
                        aria-valuenow={p.percentage}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: p.percentage + "%" }}
                      >
                        {p.percentage}%
                      </div>
                    </div>
                  </div>
                </div>
              ))}{" "}
          </div>
          <div>
            <div>
              {message.length > 0 &&
                message.map((m, index) => (
                  <div
                    className="alert alert-secondary mt-3 rounded-semi"
                    role="alert"
                    key={index}
                  >
                    {m}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;
